<div fxLayout="row" fxLayoutAlign="center center">
    <mat-spinner class="cargando" *ngIf="cargando"></mat-spinner>
</div>
<ng-container *ngIf="noCentros">
    <div class="statusDiv" fxLayout="row" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
        <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
            <h2>{{'WIZARD.CT_INFORMACION.LISTA.NOCENTROS' | translate}}</h2>
            <mat-icon class="ml-20 s-40">error_outline</mat-icon>
        </div>
    </div>
</ng-container>
<div *ngIf="!cargando && !noCentros" fxLayout="row" fxLayoutAlign="center center">
    <mat-form-field appearance="outline" class="filtro">
        <mat-label>{{'SECCIONES.PRINCIPAL.BUSCADOR' | translate}}</mat-label>
        <input matInput matInput (keyup)="applyFilter($event.target.value)" placeholder="{{'SECCIONES.PRINCIPAL.PLACE' | translate}}">
        <mat-icon matSuffix class="disabled-text">search</mat-icon>
    </mat-form-field>
</div>

<div *ngIf="!cargando">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

        <ng-container matColumnDef="nombre">
            <th mat-header-cell *matHeaderCellDef> {{'SECCIONES.PRINCIPAL.CT' | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.nombre_CT}} </td>
        </ng-container>

        <ng-container matColumnDef="direccion">
            <th mat-header-cell *matHeaderCellDef> {{'SECCIONES.PRINCIPAL.DIRECCION' | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.domicilio_CT}} </td>
        </ng-container>

        <ng-container matColumnDef="tipoCT">
            <th mat-header-cell *matHeaderCellDef> {{'SECCIONES.PRINCIPAL.TIPOCONTRATACION' | translate}} </th>
            <td mat-cell *matCellDef="let element">
                <p *ngIf="element.numColaboradores>=50">{{'SECCIONES.PRINCIPAL.MAS_50' | translate}}</p>
                <p *ngIf="element.numColaboradores<=50">{{'SECCIONES.PRINCIPAL.MENOS_50' | translate}}</p>
            </td>
        </ng-container>

        <ng-container matColumnDef="accion">
            <th mat-header-cell *matHeaderCellDef> {{'SECCIONES.PRINCIPAL.ACCIONES' | translate}} </th>
            <td mat-cell *matCellDef="let element"> <button mat-raised-button color="warn" routerLink="/NOM35/menu-resultados" (click)="centroTrabajoSeleccionado(element.productoId, element.id_CT)">{{'SECCIONES.PRINCIPAL.BOTONRESULTADOS' | translate}}</button> </td>
        </ng-container>

        <ng-container matColumnDef="download">
            <th mat-header-cell *matHeaderCellDef> {{'SECCIONES.PRINCIPAL.DESBOTONRESULTADOS' | translate}}</th>
            <td mat-cell *matCellDef="let element">
                <button mat-raised-button class="warn" (click)="descargarResultados(element.productoId, element.id_CT, element.numColaboradores, element.nombre_CT)" style="width: 3%;" style="align-content: center;">
                    <mat-icon class="ml-20" style="align-content: center;">cloud_download</mat-icon>
                 </button>

            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>

<!-- <div *ngIf="!cargando" class="contenedor" fxLayout="row" fxLayoutAlign="space-between center">
    <ng-container *ngFor="let centroTrabajo of ctTrabajo">
        <mat-card class="CT">
            <mat-card-header>
                <mat-card-title>
                    Centro de trabajo
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <h2>{{centroTrabajo.nombre_CT}}</h2>
            </mat-card-content>
            <mat-divider></mat-divider>
            <mat-card-actions>
                <button mat-raised-button color="warn" routerLink="/NOM35/menu-resultados" (click)="centroTrabajoSeleccionado(centroTrabajo.productoId, centroTrabajo.id_CT)">Ver resultados</button>
            </mat-card-actions>
        </mat-card>
    </ng-container>
</div> -->
